import React from 'react';
import { Grid } from '@material-ui/core';
import ProductCardCollection from '../ProductCard';

export default function CapsulaSection({
  capsula,
  products,
  deliverySubTitle,
  print,
  onSelectProduct,
  onRemoveProduct,
}) {
  if (!products.length) return null;
  return (
    <>
      <Grid
        container
        justifyContent="space-between"
        style={{
          marginTop: 10,
          borderBottom: '2px solid black',
          paddingBottom: 10,
          marginBottom: 10,
        }}
      >
        <div>
          <span style={{ fontWeight: 600 }}>{capsula} </span> {deliverySubTitle}
        </div>
        <span style={{ fontWeight: 600 }}>{products.length} Styles added </span>
      </Grid>
      <Grid
        container
        spacing={3}
        style={{ overflowY: 'scroll', marginTop: 10 }}
      >
        {products.map(product => (
          <ProductCardCollection
            key={product.style_code}
            product={product}
            print={print}
            onClick={() => onSelectProduct(product)}
            handleRemoveProductFromCollection={onRemoveProduct}
          />
        ))}
      </Grid>
    </>
  );
}
